<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'LegalTerms',
    computed: {
      ...mapGetters(['isStepCompleted']),
      hide: function () {
        let lastStepCondition = this.$config.enableSSN ? this.isStepCompleted(4) : false;
        return lastStepCondition;
      }
    }
  }
</script>

<template>
    <small v-if="hide">
        <Msg id="ospedali.form.legal.disclaimer"/>
    </small>
</template>